module.exports = __webpack_public_path__ + "fonts/c048e2c22831f8956e327bfbeddde074.svg";